import React from 'react';
import { Link } from 'react-router';

const NotFound = (props) => {
	return (
		<div className="not-found">
			<div className="container">
				<div className="not-found-content">
					<h1>404</h1>
					<h4>Oops! The page you are looking for doesn't exist</h4>
					<Link to="/" className="btn btn-primary">Go BACK</Link>
					<p>If this problem continues and you think something is wrong, please <Link to="/feedback">send us a report</Link> and we'll look into it.</p>
				</div>
			</div>
		</div>

	);
}

export default NotFound;
